export default __webpack_public_path__ + "static/media/parfit-toolkit.c6d53ee7.svg";